import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import './LocalDeals.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import Dropdown from 'react-bootstrap/Dropdown';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { Link } from 'react-router-dom';
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';


const LocalDeals = () => {
    const [loading, setLoading] = useState(true);
    const [deal, setDeal] = useState([]);
    const [exclusivedeal, setExclusivedeal] = useState([]);
    const [banners, setBanners] = useState([]);
    const [menuarray, setMenuarray] = useState([]);

    const [current_page, setCurrentpage] = useState(1);
    const [last_page, setLastpage] = useState(1);
    const [sortby, setSortby] = useState('');
    const [cat, setCat] = useState([]);
    const [subcat, setSubcat] = useState([]);
    const [keyword, setKeyword] = useState('');

    //const [month, setMonth] = useState('');

    const [step, setStep] = useState(false);

    const [nearbycitystatus, setNearbycitystatus] = useState(0);

    const [filter, setFilter] = useState('');

    const [homepagetagline, setHomepagetagline] = useState('');

    useEffect(() => {
        document.title = `Local Deals | Local Bells`;
        document.getElementById('bodywrap').className = 'nelocaldeals';

        localStorage.setItem("page", 0);

        API.post('get_settings')
          .then(response => {
              
              if (response.data.status === false) {

              } else {
                  setHomepagetagline(response.data.data.home_page_tag_line);
              }
          }).catch(error => {
              
          });


        if (localStorage.getItem('location_id') !== null) {

        }
        /* Start get deal */
        let formData = new FormData();
        formData.append(`per_page`, 8);
        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }

        formData.append('location_id', localStorage.getItem('location_id') || '');
        formData.append(`location_filter_type`, 1);
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    //setMonth(response.data.data.current_month);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(response.data.data.deal);
                    setExclusivedeal(response.data.data.exclusive_deal);
                    setBanners(response.data.data.banners);
                    setMenuarray(response.data.data.menu_array);
                    setNearbycitystatus(response.data.data.near_by_city_status);
                }
            }).catch(error => {
                setLoading(false);
            });
        /* End get deal */
        API.post('get_all_category')
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCat(response.data.data);
                }
            }).catch(error => {
                setLoading(false);
            });

    }, []);
    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible(true);
    };
    var adsetting = {
        dots: true,
        arrow: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,              // Enable autoplay
        autoplaySpeed: 3000,         // Set the speed for autoplay (in milliseconds)
        centerMode: false,            // Enable center mode    
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    var exdealsetting = {
        dots: true,
        arrow: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,              // Enable autoplay
        autoplaySpeed: 3000,         // Set the speed for autoplay (in milliseconds)
        centerMode: false,            // Enable center mode    
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2.1,
                    slidesToScroll: 1,
                    infinite: false,   // Optional: prevents looping, can be true
                    centerMode: false,
                    arrows: false,
                    dots: true
                }
            }
        ]
    };

    const [selected, setSelected] = useState(0);
    const [selectedcheck, setSelectedCheck] = useState(0);

    const [showInfo, setShowInfo] = useState(false);
    const handleInfo = () => {
        setShowInfo(prev => !prev);
    };
    const [hidePopInfo, setShowPopInfo] = useState(true);
    const handlePopInfo = () => {
        setShowPopInfo(false);
        //setShowInfo(false);
    };
    const getdeal = () => {
        setLoading(true);
        var currentpage = current_page + 1;
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`page`, currentpage);
        formData.append(`keyword`, keyword);
        formData.append(`type`, sortby);
        formData.append(`deal_type_filter`, filter);
        formData.append(`category`, selected);
        formData.append(`subcategory`, selectedcheck);

        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        formData.append('location_id', localStorage.getItem('location_id') || '');
        if(step===true)
        {
            formData.append(`location_filter_type`, 0);
        }else{
            formData.append(`location_filter_type`, 1);
        }
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(currentpage);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(prevDeals => [...prevDeals, ...response.data.data.deal]);

                }
            }).catch(error => {
                setLoading(false);
            });
    }
    const setSortBy = (val) => {
        setStep(false);
        setSortby(val);
        setCurrentpage(1)
        setLoading(true);
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`page`, 1);
        formData.append(`keyword`, keyword);
        formData.append(`type`, val);
        formData.append(`deal_type_filter`, filter);
        formData.append(`category`, selected);
        formData.append(`subcategory`, selectedcheck);

        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        formData.append('location_id', localStorage.getItem('location_id') || '');
        formData.append(`location_filter_type`, 1);
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(1);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(response.data.data.deal);
                    setExclusivedeal(response.data.data.exclusive_deal);
                    setBanners(response.data.data.banners);
                    setNearbycitystatus(response.data.data.near_by_city_status);
                }
            }).catch(error => {
                setLoading(false);
            });
    }
    const get_cat_deal = (id) => {
        setStep(false);
        setLoading(true);
        setFilter('');
        setSortby('');
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`page`, 1);
        formData.append(`keyword`, keyword);
        formData.append(`type`, '');
        formData.append(`category`, id);
        formData.append(`subcategory`, '');

        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        formData.append('location_id', localStorage.getItem('location_id') || '');
        formData.append(`location_filter_type`, 1);
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(1);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(response.data.data.deal);
                    setExclusivedeal(response.data.data.exclusive_deal);
                    setBanners(response.data.data.banners);
                    setNearbycitystatus(response.data.data.near_by_city_status);
                }
            }).catch(error => {
                setLoading(false);
            });
    }
    const page_deal = (id) => {
        setLoading(true);
        setSelectedCheck(0);
        get_cat_deal(id);
        let formData = new FormData();
        formData.append(`category_id`, id);
        API.post('get_all_subcategory_with_category_id', formData)
            .then(response => {
                //setLoading(false);
                if (response.data.status === false) {
                    setLoading(false);
                } else {
                    setSubcat(response.data.data);
                    setSelected(id);

                }
            }).catch(error => {
                setLoading(false);
            });
    }

    /* Start Value set */
    const handleInputChange = (event) => {
        event.persist();
        setKeyword(event.target.value);
    }
    /* End Value set */
    const search = () => {
        setStep(false);
        setLoading(true);
        setFilter('');
        setSortby('');
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`page`, 1);
        formData.append(`keyword`, keyword);
        formData.append(`type`, '');
        formData.append(`deal_type_filter`, '');
        formData.append(`category`, selected);
        formData.append(`subcategory`, selectedcheck);

        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        formData.append('location_id', localStorage.getItem('location_id') || '');
        formData.append(`location_filter_type`, 1);
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(1);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(response.data.data.deal);
                    setExclusivedeal(response.data.data.exclusive_deal);
                    setBanners(response.data.data.banners);
                    setNearbycitystatus(response.data.data.near_by_city_status);
                }
            }).catch(error => {
                setLoading(false);
            });
    }

    const all_deal = (id) => {
        setStep(false);
        setLoading(true);
        setSelectedCheck(0);
        setSelected(0);
        setFilter('');
        setSortby('');
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`page`, 1);
        formData.append(`keyword`, keyword);
        formData.append(`type`, '');

        formData.append(`category`, '');
        formData.append(`subcategory`, '');

        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        formData.append('location_id', localStorage.getItem('location_id') || '');
        formData.append(`location_filter_type`, 1);
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(1);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(response.data.data.deal);
                    setExclusivedeal(response.data.data.exclusive_deal);
                    setBanners(response.data.data.banners);
                    setNearbycitystatus(response.data.data.near_by_city_status);
                }
            }).catch(error => {
                setLoading(false);
            });
    }
    const sub_cat = (id) => {
        setStep(false);
        setLoading(true);
        setSelectedCheck(id);
         setFilter('');
        setSortby('');
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`page`, 1);
        formData.append(`keyword`, keyword);
        formData.append(`type`, '');
        formData.append(`deal_type_filter`, '');
        formData.append(`category`, selected);
        formData.append(`subcategory`, id);

        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        formData.append('location_id', localStorage.getItem('location_id') || '');
        formData.append(`location_filter_type`, 1);
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(1);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(response.data.data.deal);
                    setExclusivedeal(response.data.data.exclusive_deal);
                    setBanners(response.data.data.banners);
                    setNearbycitystatus(response.data.data.near_by_city_status);
                }
            }).catch(error => {
                setLoading(false);
            });
    }

    const handleLikeDislike = (eventKey, dealId, type) => {

        let formData = new FormData();
        formData.append('deal_id', dealId);
        formData.append('type', type);
        formData.append('like_dislike_id', eventKey);
        var url = 'deal_like_dislike_by_user';

        API.post(url, formData)
            .then(response => {
                if (response.data.status === false) {

                } else {
                    // console.log('Like success '+ response.data.data.total_like);
                    // console.log('Dislike success '+ response.data.data.total_dis_like);

                    setDeal(prevDeals =>
                        prevDeals.map(deal =>
                            deal.deal_id === dealId
                                ? {
                                    ...deal,
                                    is_liked: response.data.data.is_liked,
                                    is_dis_liked: response.data.data.is_dis_liked,
                                    total_like: response.data.data.total_like,
                                    total_dis_like: response.data.data.total_dis_like,
                                    like: response.data.data.like,
                                    dislike: response.data.data.dislike,
                                }
                                : deal
                        )
                    );

                    setExclusivedeal(prevDeals =>
                        prevDeals.map(deal =>
                            deal.deal_id === dealId
                                ? {
                                    ...deal,
                                    is_liked: response.data.data.is_liked,
                                    is_dis_liked: response.data.data.is_dis_liked,
                                    total_like: response.data.data.total_like,
                                    total_dis_like: response.data.data.total_dis_like,
                                    like: response.data.data.like,
                                    dislike: response.data.data.dislike,
                                }
                                : deal
                        )
                    );

                }
            }).catch(error => {
                setLoading(false);
                console.error('Error :', error);
            });
    };


const getNearby = () => {
        setStep(true);
        setLoading(true);
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`page`, 1);
        formData.append(`location_filter_type`, 0);
        formData.append(`keyword`, keyword);
        formData.append(`type`, sortby);
        formData.append(`deal_type_filter`, filter);
        formData.append(`category`, selected);
        formData.append(`subcategory`, selectedcheck);
                   
       
        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        formData.append('location_id', localStorage.getItem('location_id') || '');
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(1);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(prevDeals => [...prevDeals, ...response.data.data.deal]);
                }
            }).catch(error => {
                setLoading(false);
            });
    }

const setFilters = (val) => {
    setStep(false);
    setLoading(true);
    setCurrentpage(1)
    setFilter(val);

    var currentpage = 1;
    let formData = new FormData();
    formData.append(`per_page`, 8);
    formData.append(`page`, 1);
    formData.append(`keyword`, keyword);
    formData.append(`type`, sortby);
    formData.append(`deal_type_filter`, val);
    formData.append(`category`, selected);
    formData.append(`subcategory`, selectedcheck);
    formData.append(`location_filter_type`, 1);
    formData.append('location_id', localStorage.getItem('location_id') || '');
    
    var url = 'get_deal';
    if (localStorage.getItem("token")) {
        url = 'get_deal_with_login';
    }
    //formData.append('location_id', localStorage.getItem('location_id') || '');
    API.post(url, formData)
        .then(response => {
            setLoading(false);
            if (response.data.status === false) {

            } else {
                setCurrentpage(currentpage);
                setLastpage(response.data.data.pagination.last_page);
                setDeal(response.data.data.deal);
                setNearbycitystatus(response.data.data.near_by_city_status);
            }
        }).catch(error => {
            setLoading(false);
        });
}

const red_url = (url) => {
  if (url && url !== "") {
    window.location.href = url;
  }
};

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>

                            {hidePopInfo && menuarray.length <= 1 &&
                                menuarray.map((val, index) => (
                                    <div className='info-box'>
                                        <Container>

                                        <Row className='info-top'>
                                            <Col><p>{val.title}</p></Col>
                                            <Col xs="auto" className='d-flex'>
                                                <Link to="" onClick={handleInfo}> <span> {showInfo ? 'Hide Detail' : 'View Detail'} </span> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className={`img-fluid ${showInfo ? 'tr180' : ''}`} alt="drop-wh" /></Link>
                                                <Link to="" onClick={handlePopInfo}> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid info-close" alt="info" /> </Link>
                                            </Col>
                                        </Row>

                                        {showInfo && (
                                            <div className='info-bot'>
                                                <Image src={val.image} className="img-fluid" alt="info" />
                                                <p>{val.description}</p>
                                            </div>
                                        )}
                                    </Container>
                                    </div>
                                ))
                            }
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>                              

                                <Row className='ldsearch'>
                                    <Col md={12}>
                                        <InputGroup className="mb-3">
                                            <InputGroup.Text id="search" className='lds-left'>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/search.webp'} className="img-fluid" alt="search" />
                                            </InputGroup.Text>
                                            <Form.Control
                                                placeholder="Search for deals"
                                                aria-label="search"
                                                aria-describedby="search"
                                                name="keyword"
                                                onChange={handleInputChange} value={keyword}
                                            />
                                            <InputGroup.Text id="search" className='lds-right'>
                                                <Button onClick={search}>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/search-wh.webp'} className="img-fluid" alt="search" />
                                                </Button>
                                            </InputGroup.Text>
                                        </InputGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <div className="gap-3 mb-4 ld-filter-main">
                                            <div className="d-flex gap-3 align-items-center justify-content-center lfm-cat overflow-x-scroll">
                                                <div className='gap-3 d-flex ld-filter-box'>
                                                    <label
                                                        key={0}
                                                        className={selected === 0 ? 'active' : ''}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="custom-radio"
                                                            value={0}
                                                            className="d-none"
                                                            checked={selected === 0}
                                                        />
                                                        <Button
                                                            variant={'gen'}
                                                            className={''}
                                                            onClick={() => all_deal(0)}
                                                        >
                                                            All
                                                        </Button>
                                                    </label>
                                                    {cat.map((option) => {
                                                        const isSelected = selected === option.id;


                                                        const isActive = isSelected;

                                                        return (
                                                            <label
                                                                key={option.id}
                                                                className={selected === option.id ? 'active' : ''}
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    name="custom-radio"
                                                                    value={option.id}
                                                                    checked={selected === option.id}
                                                                    className="d-none"
                                                                />
                                                                <Button
                                                                    variant={selected === option.id ? 'act' : 'gen'}
                                                                    className={isActive ? 'active' : ''}
                                                                    onClick={() => page_deal(option.id)}
                                                                >
                                                                    {option.name}
                                                                </Button>
                                                            </label>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                            {selected !== 0 && (
                                                <div className='lfm-subcat'>
                                                    <h6>Popular Categories</h6>
                                                    <div className="d-flex gap-3 align-items-center overflow-x-scroll ">
                                                        <div className='gap-2 gap-sm-3 d-flex ld-filter-box'>
                                                            <label key={0} className={selectedcheck === 0 ? 'active' : ''}>
                                                                <input
                                                                    type="radio"
                                                                    name="custom-radio"
                                                                    value={0}
                                                                    className="d-none"
                                                                    checked={selected === 0}
                                                                />
                                                                <Button
                                                                    variant={'gen'}
                                                                    className={''}
                                                                    onClick={() => sub_cat(0)}
                                                                >
                                                                    All
                                                                </Button>
                                                            </label>

                                                            {subcat.length > 0 && (
                                                                <>
                                                                    {subcat.map((option) => (
                                                                        <label key={option.id} className={selectedcheck === option.id ? 'active' : ''}>
                                                                            <input
                                                                                type="radio"
                                                                                name="custom-radio"
                                                                                value={option.id}
                                                                                checked={selectedcheck === option.id}
                                                                                className="d-none"
                                                                            />
                                                                            <Button
                                                                                variant={selectedcheck === option.value ? 'act' : 'gen'}
                                                                                onClick={() => sub_cat(option.id)}
                                                                            >
                                                                                {/* <img src={option.image} alt={option.label} /> */}
                                                                                {option.name}
                                                                            </Button>
                                                                        </label>
                                                                    ))}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                                <h3 className="hm-head">{homepagetagline} <span className="org-txt">{localStorage.getItem('location')?.split('-')[0].trim()}</span></h3>
                                {banners.length > 0 ? (
                                <div className='ld-ad-banner'>
                                    {banners.length === 1 ? (
                                        <Link to={banners[0].url && banners[0].url !== "" ? banners[0].url : "#"}>
                                        <Image
                                            src={banners[0].image}
                                            className="img-fluid"
                                            alt="ad-banner"
                                        />
                                        </Link>
                                    ) : (
                                        <Slider {...adsetting}>
                                            {banners.map((val, index) => (
                                                <Image key={index} src={val.image} className="img-fluid banner-slider-img" alt="ad-banner" onClick={() => red_url(val.url)} />
                                            ))}
                                        </Slider>
                                    )}

                                </div>
                                ) : null}
                                

                                {/*<h3 className="hm-head">Only place to find <span className="blue-txt">Local Deals, Discounts</span> and <span className="blue-txt">Sale</span> in <span className="org-txt">{localStorage.getItem('location')?.split('-')[0].trim()}</span></h3>*/}

                                {exclusivedeal.length > 0 && (
                                    <>
                                        {/*<h5 className='fw-500 mb-3 mt-3'>Top Local Discounts in {localStorage.getItem('location_town') || ''} for {month} Month</h5>*/}
                                        <div className='ld-ed-box'>
                                            <div className='vm-main mb-3'>
                                                <h6 className='fw-500'>Exclusive Deal</h6>
                                                <Link to="/exclusive-deal" className="vm-link">View More</Link>
                                            </div>
                                            {exclusivedeal.length > 1 ? (
                                                <Slider {...exdealsetting}>
                                                    {exclusivedeal.map((val, index) => {
                                                        const isEven = index % 2 === 0; // even index
                                                        return (
                                                            <Col xs={6} sm={6} md={4} lg={6} xl={4} xxl={3} className='cd-single-main'>
                                                                <div className='cd-single-box'>
                                                                    {val.deal_tag && (
                                                                        isEven ? (
                                                                            <span className="user-org-label">{val.deal_tag}</span>
                                                                        ) : (
                                                                            <span className="user-org-label">{val.deal_tag}</span>
                                                                        )
                                                                    )}
                                                                    <Link to={`/neighbour/deal-details/${val.deal_id}`}>
                                                                        <Image 
                                                                            src={val.image && val.image !== "" ? val.image : process.env.REACT_APP_BASE_URL + 'assets/images/nif.jpg'} 
                                                                            className="img-fluid" 
                                                                            alt="cdeal" 
                                                                        /> 
                                                                        <div>
                                                                            <h6><Link to={`/neighbour/business-details/${val.slug}`}><span className='text-primary'>{val.business_name}</span></Link></h6>
                                                                            {(() => {
                                                                                if (val.deal_master_type === 'specific') {
                                                                                    if (val.deal_type === 1) {
                                                                                        return (<div className='d-flex align-center csb-title'>
                                                                                            <div className='d-flex'><strike className="me-2"><h5>₹ {val.original_mrp}</h5></strike><h5>₹ {val.sale_price}</h5></div>
                                                                                            <h6 class="peroff">{val.discount}% off</h6>
                                                                                        </div>)
                                                                                    } else if (val.deal_type === 2) {
                                                                                        return (<div className='d-flex align-center csb-title'>
                                                                                            <div className='d-flex'><h5>Buy {val.buy_qty} Get {val.get_qty}</h5></div>
                                                                                        </div>)
                                                                                    }
                                                                                } else if (val.deal_master_type === 'general') {
                                                                                    if (val.deal_type === 3) {
                                                                                        return (<div className='d-flex align-center csb-title'>
                                                                                            <div className='d-flex'><h5>{val.store_percent_discount}% OFF</h5></div>
                                                                                        </div>)
                                                                                    } else if (val.deal_type === 4) {
                                                                                        return (<div className='d-flex align-center csb-title'>
                                                                                            <div className='d-flex'><h5>{val.store_cash_discount} OFF</h5></div>
                                                                                        </div>)
                                                                                    }
                                                                                } else if (val.deal_master_type === 'free') {
                                                                                    return (<div className='d-flex align-center csb-title'>
                                                                                        <div className='d-flex'><h5 className="text-danger">{val.free_item}</h5></div>
                                                                                    </div>)
                                                                                }
                                                                            })()}
                                                                            <div className="title-box"><h5>{val.listing_title}</h5></div>
                                                                            <div className='cd-loc mt-2'>
                                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pinpoint.webp'} className="img-fluid" alt="pinpoint" />
                                                                                <h6>{val.address}</h6>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                    <div className='dd-ld-box cd-ld-box'>
                                                                        <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'like')}>
                                                                            <Dropdown.Toggle className={`dd-like-box ${val.is_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-like">
                                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" />
                                                                                <h6>{val.total_like}</h6>
                                                                            </Dropdown.Toggle>

                                                                            <Dropdown.Menu className='dd-like-drop'>
                                                                                {val.like.map((val1, index1) => {
                                                                                    return (
                                                                                        <Dropdown.Item className={val1.is_liked ? 'active-like' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                                    );
                                                                                })}
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                        <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'dislike')}>
                                                                            <Dropdown.Toggle className={`dd-dislike-box ${val.is_dis_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-dislike">
                                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" />
                                                                                <h6>{val.total_dis_like}</h6>
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu className='dd-dislike-drop'>
                                                                                {val.dislike.map((val1, index1) => {
                                                                                    return (
                                                                                        <Dropdown.Item className={val1.is_disliked ? 'active-dislike' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> {val1.name} </div><span>{val1.dislike_count}</span></Dropdown.Item>
                                                                                    );
                                                                                })}
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        );
                                                    })}
                                                </Slider>
                                            ) : (
                                                exclusivedeal.map((val, index) => {
                                                    const isEven = index % 2 === 0; // even index
                                                    return (
                                                        <Col xs={6} sm={6} md={4} lg={6} xl={4} xxl={3} className='cd-single-main'>
                                                            <div className='cd-single-box'>
                                                                {val.deal_tag && (
                                                                    isEven ? (
                                                                        <span className="user-org-label">{val.deal_tag}</span>
                                                                    ) : (
                                                                        <span className="user-org-label">{val.deal_tag}</span>
                                                                    )
                                                                )}
                                                                <Link to={`/neighbour/deal-details/${val.deal_id}`}>
                                                                        <Image 
                                                                            src={val.image && val.image !== "" ? val.image : process.env.REACT_APP_BASE_URL + 'assets/images/nif.jpg'} 
                                                                            className="img-fluid" 
                                                                            alt="cdeal" 
                                                                        /> 
                                                                    <div>
                                                                        <h6><Link to={`/neighbour/business-details/${val.slug}`}><span className='text-primary'>{val.business_name}</span></Link></h6>
                                                                        {(() => {
                                                                            if (val.deal_master_type === 'specific') {
                                                                                if (val.deal_type === 1) {
                                                                                    return (<div className='d-flex align-center csb-title'>
                                                                                        <div className='d-flex'><strike className="me-2"><h5>₹ {val.original_mrp}</h5></strike><h5>₹ {val.sale_price}</h5></div>
                                                                                        <h6 class="peroff">{val.discount}% off</h6>
                                                                                    </div>)
                                                                                } else if (val.deal_type === 2) {
                                                                                    return (<div className='d-flex align-center csb-title'>
                                                                                        <div className='d-flex'><h5>Buy {val.buy_qty} Get {val.get_qty}</h5></div>
                                                                                    </div>)
                                                                                }
                                                                            } else if (val.deal_master_type === 'general') {
                                                                                if (val.deal_type === 3) {
                                                                                    return (<div className='d-flex align-center csb-title'>
                                                                                        <div className='d-flex'><h5>{val.store_percent_discount}% OFF</h5></div>
                                                                                    </div>)
                                                                                } else if (val.deal_type === 4) {
                                                                                    return (<div className='d-flex align-center csb-title'>
                                                                                        <div className='d-flex'><h5>{val.store_cash_discount} OFF</h5></div>
                                                                                    </div>)
                                                                                }
                                                                            } else if (val.deal_master_type === 'free') {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><h5 className="text-danger">{val.free_item}</h5></div>
                                                                                </div>)
                                                                            }
                                                                        })()}
                                                                        <div className="title-box"><h5>{val.listing_title}</h5></div>
                                                                        <div className='cd-loc mt-2'>
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pinpoint.webp'} className="img-fluid" alt="pinpoint" />
                                                                            <h6>{val.address}</h6>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                                <div className='dd-ld-box cd-ld-box'>
                                                                    <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'like')}>
                                                                        <Dropdown.Toggle className={`dd-like-box ${val.is_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-like">
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" />
                                                                            <h6>{val.total_like}</h6>
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu className='dd-like-drop'>
                                                                            {val.like.map((val1, index1) => {
                                                                                return (
                                                                                    <Dropdown.Item className={val1.is_liked ? 'active-like' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                                );
                                                                            })}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                    <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'dislike')}>
                                                                        <Dropdown.Toggle className={`dd-dislike-box ${val.is_dis_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-dislike">
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" />
                                                                            <h6>{val.total_dis_like}</h6>
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu className='dd-dislike-drop'>
                                                                            {val.dislike.map((val1, index1) => {
                                                                                return (
                                                                                    <Dropdown.Item className={val1.is_disliked ? 'active-dislike' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> {val1.name} </div><span>{val1.dislike_count}</span></Dropdown.Item>
                                                                                );
                                                                            })}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    );
                                                })
                                            )}
                                        </div>
                                    </>
                                )}
                                {(deal.length > 0 || filter !== '' || sortby!=='') && (
                                    <>
                                <Row className='mb-4'>
                                            <Col md={12} className='d-flex justify-content-end'>
                                               
                                                <Col xs={12} className='d-flex justify-content-between'>
                                                    <div className='filter-box'>
                                                        <Dropdown>
                                                            <Dropdown.Toggle variant="success" id="filter">
                                                                <h6>{filter !== ''
                                                                    ? filter === 1
                                                                      ? 'Price Discount'
                                                                      : filter === 2
                                                                      ? 'BoGo'
                                                                      : filter === 3
                                                                      ? 'Store Sale -Store % Discount / Store Rs Discount'
                                                                      : filter === 5
                                                                      ? 'Free'
                                                                      : ''
                                                                    : 'All'}</h6>
                                                                <Image src="../assets/images/filter.webp" className="img-fluid" alt="filter" />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className='filter-drop'>
                                                                <h4 className='d-none'>Deals Filter</h4> 
                                                                <Dropdown.Item href="#" onClick={() => setFilters('')}> All </Dropdown.Item>                                                           
                                                                <Dropdown.Item href="#" onClick={() => setFilters(1)}> Price Discount </Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={() => setFilters(2)}> BoGo </Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={() => setFilters(3)}> Store Sale -Store % Discount / Store Rs Discount</Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={() => setFilters(5)}> Free </Dropdown.Item>                                                           
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div> 
                                                    <div className='sort-box'>
                                                        <Dropdown>
                                                            <Dropdown.Toggle variant="success" id="dropdown-like">
                                                                <h6>
                                                                  {sortby !== ''
                                                                    ? sortby === 'popular'
                                                                      ? 'Popular'
                                                                      : sortby === 'price_low'
                                                                      ? 'Price (Low → High)'
                                                                      : sortby === 'price_high'
                                                                      ? 'Price (High → Low)'
                                                                      : sortby === 'discount_high'
                                                                      ? '% Discount (High → Low)'
                                                                      : sortby === 'discount_low'
                                                                      ? '% Discount (Low → High)'
                                                                      : sortby === 'distance'
                                                                      ? 'Distance'
                                                                      : ''
                                                                    : 'Sort By'}
                                                                </h6>
                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/sort.webp'} className="img-fluid" alt="sort" />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu className='sort-drop ld-drop'>
                                                                <Dropdown.Item href="#" onClick={() => setSortBy('popular')}> Popular </Dropdown.Item>
                                                                {/*<Dropdown.Item href="#" onClick={() => setSortBy('popular')}> Distance </Dropdown.Item>*/}
                                                                <Dropdown.Item href="#" onClick={() => setSortBy('price_low')}> Price (Low -> High) </Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={() => setSortBy('price_high')}> Price (High -> Low) </Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={() => setSortBy('discount_high')}> % Discount (High -> Low) </Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={() => setSortBy('discount_low')}> % Discount (Low -> High) </Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={() => setSortBy('distance')}> Distance </Dropdown.Item>
                                                                {/*<Dropdown.Item href="#" onClick={() => setSortBy('free_item')}> Free Items </Dropdown.Item>*/}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </Col>
                                            </Col>
                                        </Row>
                                        </>
                                        )}
                                {deal.length > 0 && (
                                    <>
                                        
                                        <Row>
                                            {deal.map((val, index) => {
                                                const isEven = index % 2 === 0;
                                                return (
                                                    <Col xs={6} sm={6} md={4} lg={6} xl={4} xxl={3} className='cd-single-main'>
                                                        <div className='cd-single-box'>
                                                            {val.deal_tag && (
                                                                isEven ? (
                                                                    <span className="user-gre-label">{val.deal_tag}</span>
                                                                ) : (
                                                                    <span className="user-org-label">{val.deal_tag}</span>
                                                                )
                                                            )}
                                                            <Link to={`/neighbour/deal-details/${val.deal_id}`}>
                                                                        <Image 
                                                                            src={val.image && val.image !== "" ? val.image : process.env.REACT_APP_BASE_URL + 'assets/images/nif.jpg'} 
                                                                            className="img-fluid" 
                                                                            alt="cdeal" 
                                                                        /> 
                                                                <div>
                                                                    <h6><Link to={`/neighbour/business-details/${val.slug}`}><span className='text-primary'>{val.business_name}</span></Link></h6>

                                                                    {(() => {
                                                                        if (val.deal_master_type === 'specific') {
                                                                            if (val.deal_type === 1) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><strike className="me-2"><h5>₹ {val.original_mrp}</h5></strike><h5>₹ {val.sale_price}</h5></div>
                                                                                    <h6 class="peroff">{val.discount}% off</h6>
                                                                                </div>)
                                                                            } else if (val.deal_type === 2) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><h5>Buy {val.buy_qty} Get {val.get_qty}</h5></div>
                                                                                </div>)
                                                                            }
                                                                        } else if (val.deal_master_type === 'general') {
                                                                            if (val.deal_type === 3) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><h5>{val.store_percent_discount}% OFF</h5></div>
                                                                                </div>)
                                                                            } else if (val.deal_type === 4) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><h5>{val.store_cash_discount} OFF</h5></div>
                                                                                </div>)
                                                                            }
                                                                        } else if (val.deal_master_type === 'free') {
                                                                            return (<div className='d-flex align-center csb-title'>
                                                                                <div className='d-flex'><h5 className="text-danger">{val.free_item}</h5></div>
                                                                            </div>)
                                                                        }
                                                                    })()}

                                                                    <div className="title-box"><h5>{val.listing_title}</h5></div>
                                                                    <div className='cd-loc mt-2'>
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pinpoint.webp'} className="img-fluid" alt="pinpoint" />
                                                                        <h6>{val.address}</h6>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                            <div className='dd-ld-box cd-ld-box'>
                                                                <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'like')}>
                                                                    <Dropdown.Toggle className={`dd-like-box ${val.is_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-like">
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" />
                                                                        <h6>{val.total_like}</h6>
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu className='dd-like-drop'>
                                                                        {val.like.map((val1, index1) => {
                                                                            return (
                                                                                <Dropdown.Item className={val1.is_liked ? 'active-like' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                            );
                                                                        })}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                                <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'dislike')}>
                                                                    <Dropdown.Toggle className={`dd-dislike-box ${val.is_dis_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-dislike">
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" />
                                                                        <h6>{val.total_dis_like}</h6>
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu className='dd-dislike-drop'>
                                                                        {val.dislike.map((val1, index1) => {
                                                                            return (
                                                                                <Dropdown.Item className={val1.is_disliked ? 'active-dislike' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> {val1.name} </div><span>{val1.dislike_count}</span></Dropdown.Item>
                                                                            );
                                                                        })}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                        {current_page !== last_page ? (
                                          <Row className="text-center load-more">
                                            <Col md={12}>
                                              <Link to="#" className="blue-link" onClick={getdeal}>
                                                Load More
                                              </Link>
                                            </Col>
                                          </Row>
                                        ) : (
                                          nearbycitystatus===1 && step===false && (
                                            <Row className="text-center mb-4 mt-4">
                                              <Col md={12}>
                                                <p>
                                                  All deals viewed! Want to explore nearby towns?{' '}
                                                  <Link to="#" onClick={getNearby}>Click here</Link>
                                                </p>
                                              </Col>
                                            </Row>
                                          )
                                        )}
                                    </>
                                )}
                                {loading === false && exclusivedeal.length <=0 && deal.length <= 0 && (<><Row className='nodeal'>
                                    <Col className="mt-5 mb-3">
                                        <h3>No deals in yet — but we're coming soon!</h3>
                                        <p>Own a local business or know someone? Register your business free, go online in a minute, and grow locally by offering deals today. <Link to="/business/register">Click to Register</Link></p>
                                    </Col>
                                </Row></>)}


                                {loading === false && exclusivedeal.length <= 0 && deal.length <= 0 && nearbycitystatus===1 && step===false  && (<>
                                    <Row className="text-center  mb-4">
                                      <Col md={12}>
                                        <p>
                                          All deals viewed! Want to explore nearby towns?{' '}
                                          <Link to="#" onClick={getNearby}>Click here</Link>
                                        </p>
                                      </Col>
                                    </Row>
                                </>)}


                                <div className='footer-main footer'>
                                    <Footer />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default LocalDeals;